/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { DataTableFragmentDoc } from "../../dim-configuration/graphql/product-configuration.fragments.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProductInformationWithoutAddonsFragment = {
  __typename: "ProductInformation"
  productType: string
  variantKey: string
  configurationKey?: string | null
  title: string
  shortTitle: string
  productKind: string
  price?: number | null
  priceGroup?: string | null
  attributes: Array<{
    __typename: "ProductAttribute"
    value: string
    label: string
    valueShort?: string | null
  }>
  picture?: {
    __typename: "ProductPicture"
    url: string
    title?: string | null
    alternativeText?: string | null
  } | null
  quickInfos?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  generalDescription?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  variantDescription?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  attributesTable?: {
    __typename: "DataTable"
    description?: string | null
    body?: Array<Array<{
      __typename: "DataTableCell"
      index?: number | null
      key?: string | null
      value?: any
    }> | null> | null
    header?: Array<{
      __typename: "DataTableCell"
      index?: number | null
      key?: string | null
      value?: any
    }> | null
  } | null
  dimensioning?: {
    __typename: "ProductDimensioning"
    supplementaryText?: string | null
    environmentalAttributes?: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }> | null
    physicalAttributes?: Array<{
      __typename: "PhysicalAttribute"
      value?: number | null
      unit?: string | null
      label: string
    }> | null
    physicalTables?: Array<{
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    }> | null
  } | null
  deliveryTime?: {
    __typename: "ProductDeliveryTime"
    type: string
    days?: number | null
    week?: number | null
    quarter?: number | null
    year?: number | null
  } | null
}

export type ProductInformationFragment = {
  __typename: "ProductInformation"
  productType: string
  variantKey: string
  configurationKey?: string | null
  title: string
  shortTitle: string
  productKind: string
  price?: number | null
  priceGroup?: string | null
  addons?: Array<{
    __typename: "ProductInformation"
    productType: string
    variantKey: string
    configurationKey?: string | null
    title: string
    shortTitle: string
    productKind: string
    price?: number | null
    priceGroup?: string | null
    attributes: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }>
    picture?: {
      __typename: "ProductPicture"
      url: string
      title?: string | null
      alternativeText?: string | null
    } | null
    quickInfos?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    generalDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    variantDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    attributesTable?: {
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    } | null
    dimensioning?: {
      __typename: "ProductDimensioning"
      supplementaryText?: string | null
      environmentalAttributes?: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }> | null
      physicalAttributes?: Array<{
        __typename: "PhysicalAttribute"
        value?: number | null
        unit?: string | null
        label: string
      }> | null
      physicalTables?: Array<{
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      }> | null
    } | null
    deliveryTime?: {
      __typename: "ProductDeliveryTime"
      type: string
      days?: number | null
      week?: number | null
      quarter?: number | null
      year?: number | null
    } | null
  }> | null
  attributes: Array<{
    __typename: "ProductAttribute"
    value: string
    label: string
    valueShort?: string | null
  }>
  picture?: {
    __typename: "ProductPicture"
    url: string
    title?: string | null
    alternativeText?: string | null
  } | null
  quickInfos?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  generalDescription?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  variantDescription?: {
    __typename: "ProductInformationTextField"
    label: string
    value: string
  } | null
  attributesTable?: {
    __typename: "DataTable"
    description?: string | null
    body?: Array<Array<{
      __typename: "DataTableCell"
      index?: number | null
      key?: string | null
      value?: any
    }> | null> | null
    header?: Array<{
      __typename: "DataTableCell"
      index?: number | null
      key?: string | null
      value?: any
    }> | null
  } | null
  dimensioning?: {
    __typename: "ProductDimensioning"
    supplementaryText?: string | null
    environmentalAttributes?: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }> | null
    physicalAttributes?: Array<{
      __typename: "PhysicalAttribute"
      value?: number | null
      unit?: string | null
      label: string
    }> | null
    physicalTables?: Array<{
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    }> | null
  } | null
  deliveryTime?: {
    __typename: "ProductDeliveryTime"
    type: string
    days?: number | null
    week?: number | null
    quarter?: number | null
    year?: number | null
  } | null
}

export type ProductInformationTextFieldFragment = {
  __typename: "ProductInformationTextField"
  label: string
  value: string
}

export type DeliveryTimeActiveImportFragment = {
  __typename: "DeliveryTimeActiveImport"
  contentLength: number
  importedAt: string
  uploaderName: string
  uploaderEmail: string
  fileName: string
  readUrl: string
  status: string
}

export type ProductDeliveryTimeFragment = {
  __typename: "ProductDeliveryTime"
  type: string
  days?: number | null
  week?: number | null
  quarter?: number | null
  year?: number | null
}

export const ProductInformationTextFieldFragmentDoc = gql`
  fragment ProductInformationTextField on ProductInformationTextField {
    label
    value
  }
`
export const ProductDeliveryTimeFragmentDoc = gql`
  fragment ProductDeliveryTime on ProductDeliveryTime {
    type
    days
    week
    quarter
    year
  }
`
export const ProductInformationWithoutAddonsFragmentDoc = gql`
  fragment ProductInformationWithoutAddons on ProductInformation {
    productType
    variantKey
    configurationKey
    title
    shortTitle
    productKind
    price
    priceGroup
    attributes {
      value
      label
      valueShort
    }
    picture {
      url
      title
      alternativeText
    }
    quickInfos @type(name: "ProductInformationTextField") {
      ...ProductInformationTextField
    }
    generalDescription @type(name: "ProductInformationTextField") {
      ...ProductInformationTextField
    }
    variantDescription @type(name: "ProductInformationTextField") {
      ...ProductInformationTextField
    }
    attributesTable @type(name: "DataTable") {
      ...DataTable
    }
    dimensioning @type(name: "ProductDimensioning") {
      supplementaryText
      environmentalAttributes @type(name: "PhysicalAttribute") {
        value
        label
        valueShort
      }
      physicalAttributes @type(name: "PhysicalAttribute") {
        value
        unit
        label
      }
      physicalTables @type(name: "DataTable") {
        ...DataTable
      }
    }
    deliveryTime @type(name: "ProductDeliveryTime") {
      ...ProductDeliveryTime
    }
  }
  ${ProductInformationTextFieldFragmentDoc}
  ${DataTableFragmentDoc}
  ${ProductDeliveryTimeFragmentDoc}
`
export const ProductInformationFragmentDoc = gql`
  fragment ProductInformation on ProductInformation {
    ...ProductInformationWithoutAddons
    addons @type(name: "ProductInformation") {
      ...ProductInformationWithoutAddons
    }
  }
  ${ProductInformationWithoutAddonsFragmentDoc}
`
export const DeliveryTimeActiveImportFragmentDoc = gql`
  fragment DeliveryTimeActiveImport on DeliveryTimeActiveImport {
    contentLength
    importedAt
    uploaderName
    uploaderEmail
    fileName
    readUrl
    status
  }
`
